import { ApiClient } from "../../ApiClient"
import { mapNews } from "../../mappers/newsMapper";
import { GetNewResponse } from '../schema/GetNewResponse';
import { News } from "@/@types";
import { _news } from "@/_mock/_home"

export const getAllNews = async (): Promise<News[]> => {

  const client = ApiClient.getInstance()
  const response = await client.get<GetNewResponse>("home/news")

  return response.data.map(mapNews);
}

